// On admin.<host> the SPA derives redirect / logout URIs from window.location.origin so
// the post-login flow lands back on admin.* instead of the bare host configured in the
// container env vars. Bare-host flow is unchanged (still reads the env-baked values).
//
// Auth0 application setup (Diptek Pulse SPA app, both dev + prod tenants):
//   Allowed Callback URLs +=  https://admin.<host>/startSession
//   Allowed Logout URLs   +=  https://admin.<host>
//   Allowed Web Origins   +=  https://admin.<host>
const isAdminHost = typeof window !== 'undefined' &&
    typeof window.location !== 'undefined' &&
    typeof window.location.hostname === 'string' &&
    window.location.hostname.toLowerCase().startsWith('admin.');

export const AUTH_CONFIG = {
    domain: window._env_.REACT_APP_AUTH0_DOMAIN,
    clientID: window._env_.REACT_APP_AUTH0_CLIENTID,
    redirectUri: isAdminHost
        ? `${window.location.origin}/startSession`
        : window._env_.REACT_APP_AUTH0_REDIRECTURI,
    audience: window._env_.REACT_APP_AUTH0_AUDIENCE,
    logoutUri: isAdminHost
        ? window.location.origin
        : window._env_.REACT_APP_AUTH0_LOGOUTURI
};